// Minimal Redux slice for global ImageView - using shared ACTIONS constants
import ACTIONS from 'store/constants';

export const openImageViewer = (payload: { imageUrl: string; imageName?: string }) => ({
  type: ACTIONS.IMAGE_VIEWER_OPEN,
  payload,
});

export const closeImageViewer = () => ({ type: ACTIONS.IMAGE_VIEWER_CLOSE });

export type ImageViewerState = {
  isOpen: boolean;
  imageUrl: string | null;
  imageName?: string;
};

const initialState: ImageViewerState = {
  isOpen: false,
  imageUrl: null,
  imageName: undefined,
};

export default function imageViewerReducer(
  state: ImageViewerState = initialState,
  action: any
): ImageViewerState {
  switch (action.type) {
    case ACTIONS.IMAGE_VIEWER_OPEN:
      return {
        isOpen: true,
        imageUrl: action.payload?.imageUrl || null,
        imageName: action.payload?.imageName,
      };
    case ACTIONS.IMAGE_VIEWER_CLOSE:
      return initialState;
    default:
      return state;
  }
}


